import { useQueryClient } from "@tanstack/react-query";
import { useToggleStockArticleActivationMutation } from "@/hooks/mutations/useToggleStockArticleActivation";
import { useDeleteStockArticleMutation } from "@/hooks/mutations/useDeleteStockArticle";
import { queryKeys } from "@/lib/query-keys";
import type { StockArticle } from "@/lib/stock.api";

export function useStockArticleActions() {
  const queryClient = useQueryClient();
  const toggleMutation = useToggleStockArticleActivationMutation();
  const deleteMutation = useDeleteStockArticleMutation();

  function reloadStock() {
    queryClient.invalidateQueries({ queryKey: queryKeys.stock() });
    queryClient.invalidateQueries({ queryKey: queryKeys.stockMovements() });
  }

  function toggleActive(article: StockArticle) {
    toggleMutation.mutate({ id: article.id, active: !article.active });
  }

  function deleteArticle(article: StockArticle, onDone?: () => void) {
    deleteMutation.mutate(article.id, { onSuccess: onDone });
  }

  return {
    reloadStock,
    toggleActive,
    toggling: toggleMutation.isPending,
    deleteArticle,
    deleting: deleteMutation.isPending,
  };
}
